import React from "react";
import { Droppable } from "react-beautiful-dnd";
import IndividualTagComponent from "./IndividualTag";

const HorizontalDragComponent = ({
	tagsData,
	editIcon,
	editClickHandler,
	deleteIcon,
	deleteClickHandler,
	isDragDisabled
}) => {

	return (
		<Droppable droppableId="droppable" direction="horizontal">
			{provided => (
				<div
					{...provided.dragHandleProps}
					ref={provided.innerRef}
					className="sx w-100 d-flex my-1 flex-wrap"
				>
					{tagsData.map((tagData, index) => (
						<IndividualTagComponent
							id={tagData?.id}
							tagData={tagData}
							draggableId={tagData?.id}
							index={index}
							key={tagData?.id}
							tagText={tagData?.name}
							editIcon={editIcon}
							editClickHandler={(e) => editClickHandler(e, tagData)}
							deleteIcon={deleteIcon}
							deleteClickHandler={e => deleteClickHandler(e, tagData)}
							isDragDisabled={isDragDisabled}
						/>
					))}
					{provided.placeholder}
				</div>
			)}
		</Droppable>
	);
};

export default HorizontalDragComponent;
